<template>
  <v-container>
    <v-flex xs12 sm12 md8 lg8 xl6 style="margin:auto">
      <v-card>
        <v-card-text>
          <v-form>
            <h4 class="primary--text">Upload File </h4>
<!--            <v-text-field type="text" :label="'Theme Name*'" v-model.trim="themeName"
                          name="themeName"
                          key="themeName"
                          v-validate="'required'" maxLength="50"
                          :error-messages="errors.first('themeName')"
                          :data-vv-as="'themeName'"
            ></v-text-field>-->
            <v-text-field type="text" :label="'Link Url'" v-model.trim="themeUrl"
                          name="fullName"
                          key="fullName"
                          :disabled="true"
                          v-validate="'required'" maxLength="50"
                          :error-messages="errors.first('Link Url')"
                          :data-vv-as="$t('lang.user.fullName')"
            ></v-text-field>
            <div style="text-align: center">
              <i-upload :label="'Upload File'"
                        v-model.trim="attachId" :multifile="false"
                        name="attachId"
                        :data-vv-as="$t('Upload File')"
                        :error-messages="errors.first('Upload File')"
              />
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="yoprimary" dark @click="handleSubmit">
            {{$t('lang.common.save')}}
          </v-btn>
          <v-btn class="primary" dark @click="getDataCopy">
            {{'Copy URL'}}
          </v-btn>
<!--          <v-btn color="cancel" @click="back">
            {{$t('lang.common.back')}}
          </v-btn>-->
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
import IDatepicker from "@/components/form/DatePicker";
import IUpload from "@/components/form/Upload";
import {mapState} from "vuex";
import {CrudService, message} from "@/services";
import axios from "axios";
import {Validator} from "vee-validate";

export default {
  name: "Profile",
  components: {IDatepicker, IUpload},
  data() {
    return {
      submitted: false,
      user: {
        status: 1
      },
      values: {},
      lstProvice:[],
      themeUrl : this.themeUrl,
      attachId: null,
      profile: {
        'workingAt': '',
        'experience': '',
        'email': '',
        'yoTarget': '',
        'cvId': null
      },
      disablePhone:false,
      disableEmail:false
    };
  },
  computed: mapState({
    loading: state => state.common.loading,
  }),
  methods: {
    getDataCopy(){
      axios.post(
          process.env.VUE_APP_API_URL + "/notify/searchAllUrl1", {status: 1}
      )
          .then(
              (data) => {
                if (data != null && data != "") {
                  var dataJson = JSON.parse(data.items[0].content);
                  console.log(dataJson.themeName);
                  this.themeUrl = dataJson.url;
                  this.copyURL1(this.themeUrl);
                } else {
                  this.themeUrl = '';
                }
              },
              error => {
                console.log(error);
              }
          );
    },
    copyURL1(myText) {
      console.info(myText);
      navigator.clipboard.writeText(myText)
      //document.execCommand(myText);
      message.success(
          this.$t("Copy Url thành công!!!")
      );
    },
    handleSubmit(e) {
      this.submitted = true;
      console.log("user:", this.user);
      this.$validator.validate().then(valid => {
        if (valid) {
          this.profile.themeUrl = this.url;
          this.profile.attachId = this.attachId;

          axios.post(process.env.VUE_APP_API_URL + "/notify/saveUrl", this.profile).then(
              data => {
                if (data.success) {
                  message.success(this.$t('lang.common.update_success'));
                  location.reload();
                } else {
                  message.error(this.$t(data.message));
                }
              },
              error => {
                message.error(error);

              }
          )
        } else {
          message.error("Bạn nhập thiếu thông tin hoặc thông tin không đúng định dạng");
        }
      });
      return false;
    },
    back() {
      this.$router.go(-2);
    }
  },
  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/notify/searchAllUrl1", {status: 1}
    )
        .then(
            (data) => {
              if (data != null && data != "") {
                var dataJson = JSON.parse(data.items[0].content);
                console.log(dataJson.themeName);
                this.themeUrl = dataJson.url;

              } else {
                this.themeUrl = '';
              }
            },
            error => {
              console.log(error);
            }
        );
  },
  mounted() {
    let me = this;
    const usernameUnique = (value) => {
      if (me.initUsername == value) {
        return true;
      }
      return axios.get(`${process.env.VUE_APP_API_URL}/user/validate-username?username=${value}`).then((data) => {
        //debugger;
        return {
          valid: data.valid,
          data: {
            message: data.message
          }
        };
      });
    };

    if (this.$route.params.id) {
      this.$refs.password.focus();
    }
  }
};
</script>